import Vue from 'vue'
import VueRouter from 'vue-router'
import { ValidationProvider } from 'vee-validate'
import VueMask from 'v-mask'

import App from './App.vue'

import About from './components/about.vue'
import Home from './components/home.vue'


Vue.component('ValidationProvider', ValidationProvider)
Vue.use(VueRouter)
Vue.use(VueMask)


const routes = [
  { path: '/', component: Home },
  { path: '/home', component: Home },
  { path: '/about', component: About }
];

const router = new VueRouter({
  routes
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
